import React, { useState } from 'react';
import ArrangementSuppliedItemSelector from '../shared/arrangement_supplied_item_selector';

const getDefaultSuppliedItemIds = (): number[] => {
  const suppliedItemIds = utils.getParam('supplied_item_ids');
  if (!suppliedItemIds) {
    return [];
  }
  return suppliedItemIds.split(',').map((id: string) => parseInt(id, 10));
};

type UseSuppliedItemSelectorReturn = [number[], () => JSX.Element, ((ids: number[]) => void)?];

const useSuppliedItemSelector = (): UseSuppliedItemSelectorReturn => {
  const [suppliedItemIds, setSuppliedItemIds] = useState<number[]>(getDefaultSuppliedItemIds());

  const renderSuppliedItemSelector = () => (
    <ArrangementSuppliedItemSelector
      selectedSuppliedItemIds={suppliedItemIds}
      onSelect={ids => setSuppliedItemIds(ids)}
    />
  );

  return [suppliedItemIds, renderSuppliedItemSelector, setSuppliedItemIds];
};

export default useSuppliedItemSelector;
